<!-- 操作 -->
<template>
    <div class="guide">
        <div class="guide-block"></div>
        <question />

        <div class="guide-button">
            <van-button type="info" @click="service" class="button">
                <template #default>
                    <div class="guide-item flex align-center">
                        <img src="../../assets/images/operationGuide/service.png" alt="" />
                        <p style="color: #fff">客服热线</p>
                    </div>
                </template>
            </van-button>
            <van-button type="info" to="suggestion" class="button">
                <template #default>
                    <div class="guide-item flex align-center">
                        <img src="../../assets/images/operationGuide/opinion.png" alt="" />
                        <p style="color: #fff">反馈意见</p>
                    </div>
                </template>
            </van-button>
        </div>
        <DialogSlot :show.sync="showDialog" leftBtnText="取消" @handleLeftBtn="showDialog = false">
            <template v-slot:content>
                <div class="dialog-container">
                    <van-list>
                        <van-cell-group>
                            <van-cell title="呼叫" @click="call">
                                <a href="tel:10086">呼叫</a>
                            </van-cell>
                            <van-cell title="复制" @click="copy" />
                            <van-cell title="添加到通讯录" @click="addAddressBook">
                                <a href="wtai://wp//ap;10086">添加到通讯录</a>
                            </van-cell>
                        </van-cell-group>
                    </van-list>
                </div>
            </template>
        </DialogSlot>
    </div>
</template>

<script>
import DialogSlot from "@/components/base/dialogSlot/dialog-slot.vue";
import Question from "@/components/question/question.vue";
import { zzconfig } from "@/config/zzconfig";
export default {
    name: "operationGuide",
    components: {
        DialogSlot,
        Question,
    },
    data() {
        return {
            showDialog: false, //客服热线弹出层
        };
    },

    computed: {},

    mounted() {},

    methods: {
        //客服热线
        service() {
            window.location.href = `tel:${zzconfig.PHONE}`;
        },

        hideDialog() {},
        //呼叫
        call() {},
        //复制
        copy() {},
        //添加到通讯录
        addAddressBook() {},
    },
};
</script>
<style lang="less" scoped>
.dialog-container {
    margin-top: 20px;
    text-align: center;
}
.guide-block {
    height: 16px;
}
.guide {
    // padding-top: 24px;
    height: calc(~"100vh - 88px - 35px");
    overflow: auto;
    .guide-img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
    }
    .guide-button {
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        bottom: 0;
        z-index: 10;
        height: 120px;
        width: 100%;
        background-color: #fff;

        .button {
            width: 300px;
            border-radius: 20px;

            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        }
    }
}
.guide-item {
    div {
        width: 32px;
        height: 32px;
    }

    img {
        width: 32px;
        height: 32px;
    }
    p {
        font-size: 28px;
        color: #333333;
        margin-left: 17px;
    }
}
</style>
